var _style, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImage404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\xD1\\xEB\\xEE\\xE9_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1600 405.91",
    style: {
      enableBackground: "new 0 0 1600 405.91"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M795.58,226.66c4.74,0,8.63,4.14,8.63,9.31c0,5.11-3.89,9.22-8.63,9.22l-54.87-0.01l0-18.53L795.58,226.66z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M579.67,220.29l5.48-0.05l-0.07-6.3l1.41-0.02c1.49,0.1,2.89,0.06,4.28-0.02l0.08,6.27l5.26-0.06 l-0.07-6.28l4.93-0.06c0.02-0.12,0.05-0.23,0.08-0.35c0.06-0.01-0.92-0.02-0.86-0.04l0.19,6.24c0.17,2.18,2.15,3.98,4.41,4 l15.48-0.3c2.74,7.26,6.78,13.8,11.82,19.23c9.83,10.59,23.42,17.14,38.41,17.14l29.32,0.01c0.11,10.47,8.03,18.88,17.69,18.89 c4.88,0,9.38-2.1,12.58-5.56c2.64-2.84,4.44-6.62,4.99-10.84l0.03-120.84c-1.19-9.34-8.58-16.52-17.56-16.53 c-4.89,0-9.28,2.18-12.47,5.57c-2.98,3.21-4.89,7.45-5.17,12.18h-0.06l-29.32-0.01c-25.27-0.01-46.57,18.69-52.58,43.94 c-0.03,0.1-0.05,0.21-0.07,0.31c-0.01-0.18-0.02-0.37-0.02-0.55L604,186.47c-2.26-0.02-3.97,1.74-3.8,3.92l-0.09,5.62 c-0.09,0.01-0.19,0.02-0.28,0.03c-0.23-0.02-0.45-0.05-0.69-0.06c-1.18-0.04-2.25,0.06-3.27,0.21l-0.06-5.91l-5.3,0.06 l0.06,6.28l-5.68,0.06l-0.06-6.3l-5.5,0.06L579.67,220.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M804.22,166.22c0,5.11-3.89,9.23-8.63,9.23l-54.87-0.01l0-18.53l54.87,0.01 C800.33,156.91,804.22,161.11,804.22,166.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M856.31,146.31h0.06c0.28-4.73,2.19-8.96,5.17-12.18c3.19-3.39,7.58-5.57,12.47-5.57 c8.99,0,16.37,7.18,17.56,16.52l-0.03,120.84c-0.55,4.22-2.36,8-4.99,10.84c-3.2,3.46-7.7,5.56-12.58,5.56 c-9.67,0-17.58-8.42-17.69-18.89L856.31,146.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M976.81,223.85c-0.03,0.13-0.07,0.25-0.1,0.37c0-0.1,0.01-0.2,0.01-0.31c-0.08-12.3-1.07-24.62-1.09-36.92 l19.59-0.31c2.26,0.02,4.24,1.82,4.41,4l0.17,5.85l4.15-0.05l-0.07-6.28l5.26-0.06l0.08,6.27c1.39-0.08,2.79-0.11,4.28-0.02 l1.41-0.02l-0.07-6.3l5.48-0.05l0.33,29.84l-5.5,0.06l-0.06-6.3l-5.68,0.06l0.06,6.28l-5.3,0.06l-0.06-5.91 c-1.02,0.15-2.08,0.25-3.27,0.21c-0.24-0.01-0.46-0.04-0.69-0.06c-0.09,0.01-0.19,0.02-0.28,0.03l-0.09,5.62 c0.17,2.18-1.54,3.94-3.8,3.92l-19.1,0.24c-0.01-0.18-0.02-0.37-0.02-0.55C976.86,223.64,976.84,223.75,976.81,223.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M939.41,145c5.97-0.03,10.83,4.79,10.86,10.76l0.46,99.22c0.03,5.97-4.79,10.83-10.76,10.86l-68.36,0.32 c-5.97,0.03-10.83-4.79-10.86-10.76l-0.46-99.22c-0.03-5.97,4.79-10.83,10.76-10.86L939.41,145z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M893.25,158.35c-13.46,0.06-24.32,11.02-24.26,24.48l0.21,45.82c0.06,13.46,11.02,24.32,24.48,24.26 l65.32-0.3c13.46-0.06,24.32-11.02,24.26-24.48l-0.21-45.82c-0.06-13.46-11.02-24.32-24.48-24.26L893.25,158.35z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M847.01,74.84c-0.96,2.69-3.93,4.1-6.62,3.14l0,0c-2.7-0.96-4.1-3.93-3.14-6.62l7.33-23.8 c0.96-2.69,3.93-4.1,6.62-3.14l0,0c2.69,0.96,4.1,3.93,3.14,6.62L847.01,74.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M753.17,71.88c1,2.68-0.37,5.66-3.05,6.66l0,0c-2.68,1-5.66-0.37-6.66-3.05l-9.68-22.94 c-1-2.68,0.37-5.66,3.05-6.66l0,0c2.68-1,5.66,0.37,6.66,3.05L753.17,71.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M800.35,65.09c0.02,2.86-2.29,5.2-5.15,5.21l0,0c-2.86,0.02-5.2-2.29-5.21-5.15l-0.32-50.36 c-0.02-2.86,2.29-5.2,5.15-5.21l0,0c2.86-0.02,5.2,2.29,5.21,5.15L800.35,65.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M712.09,92.75c1.85,2.18,1.59,5.45-0.59,7.3l0,0c-2.18,1.85-5.45,1.59-7.3-0.59l-32.61-38.37 c-1.85-2.18-1.59-5.45,0.59-7.3l0,0c2.18-1.85,5.45-1.59,7.3,0.59L712.09,92.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M911.67,54.56c1.83-2.2,5.09-2.51,7.3-0.68l0,0c2.2,1.83,2.51,5.09,0.68,7.3l-32.13,38.78 c-1.83,2.2-5.09,2.51-7.29,0.68l0,0c-2.2-1.83-2.51-5.09-0.68-7.29L911.67,54.56z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M847.01,331.08c-0.96-2.7-3.93-4.1-6.62-3.14l0,0c-2.7,0.96-4.1,3.93-3.14,6.62l7.33,23.8 c0.96,2.7,3.93,4.1,6.62,3.14l0,0c2.69-0.96,4.1-3.93,3.14-6.62L847.01,331.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M753.17,334.03c1-2.68-0.37-5.66-3.05-6.66l0,0c-2.68-1-5.66,0.37-6.66,3.05l-9.68,22.94 c-1,2.68,0.37,5.66,3.05,6.66l0,0c2.68,1,5.66-0.37,6.66-3.05L753.17,334.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M800.35,340.83c0.02-2.86-2.29-5.2-5.15-5.21l0,0c-2.86-0.02-5.2,2.29-5.21,5.15l-0.32,50.36 c-0.02,2.86,2.29,5.2,5.15,5.21l0,0c2.86,0.02,5.2-2.29,5.21-5.15L800.35,340.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M712.09,313.16c1.85-2.18,1.59-5.45-0.59-7.3l0,0c-2.18-1.85-5.45-1.59-7.3,0.59l-32.61,38.37 c-1.85,2.18-1.59,5.45,0.59,7.3l0,0c2.18,1.85,5.45,1.59,7.3-0.59L712.09,313.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M911.67,351.35c1.83,2.2,5.09,2.51,7.3,0.68l0,0c2.2-1.83,2.51-5.09,0.68-7.3l-32.13-38.78 c-1.83-2.2-5.09-2.51-7.29-0.68l0,0c-2.2,1.83-2.51,5.09-0.68,7.29L911.67,351.35z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M889.78,208.28c-0.21,0.75-0.45,1.49-0.7,2.22l710.92-0.4v-12.5L891,198 C891.11,201.38,890.73,204.84,889.78,208.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M693.84,198.08L0,198.47v12.5l694.41-0.39C693.47,206.48,693.29,202.23,693.84,198.08z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage404);
export default __webpack_public_path__ + "static/media/image404.64a35c1a8c7b2df9a441884c58bd44b5.svg";
export { ForwardRef as ReactComponent };